import React from 'react';
import { EntityTaskDetails } from 'components/common/tasks/entityTaskDetails';

export const SupplierTaskDetails = () => {
  return <EntityTaskDetails entityName={'SUPPLIER'} />;
};
